document.addEventListener('DOMContentLoaded', () => {
    const timerElement = document.getElementById('countdown-timer');
    const deliveryElement = document.getElementById('delivery_days');
    const userLocale = navigator.language || 'en-US'; // Fallback to en-US if locale not detected

    function updateDeliveryInfo() {
        const now = new Date(); // Uses user's local timezone (e.g., PKT UTC+5, GST UTC+4)
        
        // Console log current time in format "HH:mm:ss M/D/YYYY"
        // console.log(`Current time: ${now.toLocaleTimeString('en-US', { hour12: false })} ${now.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' })}`);

        const hours = now.getHours();
        const minutes = now.getMinutes();
        const seconds = now.getSeconds();
        const dayOfWeek = now.getDay(); // 0 (Sunday) to 6 (Saturday)

        // Calculate time until 16:00 in local timezone
        const targetTime = new Date(now);
        targetTime.setHours(16, 0, 0, 0);
        if (now > targetTime) {
            targetTime.setDate(targetTime.getDate() + 1); // Move to next day's 16:00
        }
        const timeDiff = targetTime - now;
        const hoursLeft = Math.floor(timeDiff / (1000 * 60 * 60));
        const minutesLeft = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const secondsLeft = Math.floor((timeDiff % (1000 * 60)) / 1000);

        let deliverTomorrow = false;

        // Format countdown timer
        timerElement.textContent = `${hoursLeft.toString().padStart(2, '0')}:${minutesLeft.toString().padStart(2, '0')}:${secondsLeft.toString().padStart(2, '0')}`;

        // Calculate delivery date
        let deliveryDate = new Date(now);
        if (hours < 16) {
            // Orders before 16:00
            if (dayOfWeek === 6) {
                // Saturday before 16:00 -> Monday
                deliveryDate.setDate(now.getDate() + 2);
            }
            else if (dayOfWeek === 0) {
                // Saturday before 16:00 -> Monday
                deliveryDate.setDate(now.getDate() + 2);
            } else {
                // Other days before 16:00 -> Next day
                deliveryDate.setDate(now.getDate() + 1);
                deliverTomorrow = true;
            }
        } else {
            // Orders after 16:00
            if (dayOfWeek === 6) {
                // Saturday after 16:00 -> Tuesday
                deliveryDate.setDate(now.getDate() + 3);
            }
            else if (dayOfWeek === 0) {
                // Saturday before 16:00 -> Monday
                deliveryDate.setDate(now.getDate() + 2);
            }  else {
                // Other days after 16:00 -> Day after tomorrow
                deliveryDate.setDate(now.getDate() + 2);
            }
        }

        // Format delivery date using user's locale (e.g., "4 June" or "4 يونيو")
        // const options = { day: 'numeric', month: 'long' };console.log('deliveryDate', deliveryDate);
        // deliveryElement.textContent = deliveryDate.toLocaleDateString(userLocale, options);
        const options = { weekday: 'long' }; // Only the weekday name
        if(deliverTomorrow){
          deliveryElement.textContent = 'morgen';
        }else{
          deliveryElement.textContent = deliveryDate.toLocaleDateString('nl-NL', options); // Force Dutch locale
        }

    }

    // Update immediately and then every second
    updateDeliveryInfo();
    setInterval(updateDeliveryInfo, 1000);
});
document.addEventListener('DOMContentLoaded', () => {
  const userLocale = navigator.language || 'en-US';
  let timerInterval;

  function updateCartDeliveryInfo() {
    const cartTimerElement = document.getElementById('cartdrawer_countdown-timer');
    const cartDeliveryElement = document.getElementById('cartdrawer_delivery_days');

    if (!cartTimerElement || !cartDeliveryElement) return;

    const now = new Date();
    const hours = now.getHours();
    const dayOfWeek = now.getDay();

    const targetTime = new Date(now);
    targetTime.setHours(16, 0, 0, 0);
    if (now > targetTime) {
      targetTime.setDate(targetTime.getDate() + 1);
    }

    const timeDiff = targetTime - now;
    const hoursLeft = Math.floor(timeDiff / (1000 * 60 * 60));
    const minutesLeft = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const secondsLeft = Math.floor((timeDiff % (1000 * 60)) / 1000);

    const timerText = `${hoursLeft.toString().padStart(2, '0')}:${minutesLeft
      .toString()
      .padStart(2, '0')}:${secondsLeft.toString().padStart(2, '0')}`;

    cartTimerElement.textContent = timerText;

    if (timerText === '00:00:00') {
      // console.log('Timer reached 00:00:00, restarting...');
      clearInterval(timerInterval);
      setTimeout(() => {
        startTimer(); // restart timer logic after short delay
      }, 500);
      return;
    }

    // Set delivery day
    let deliveryDate = new Date(now);
    if (hours < 16) {
      deliveryDate.setDate(now.getDate() + (dayOfWeek === 6 ? 2 : 1));
    } else {
      deliveryDate.setDate(now.getDate() + (dayOfWeek === 6 ? 3 : 2));
    }

    const options = { day: 'numeric', month: 'long' };
    cartDeliveryElement.textContent = deliveryDate.toLocaleDateString(userLocale, options);
  }

  function startTimer() {
    updateCartDeliveryInfo(); // run once
    timerInterval = setInterval(updateCartDeliveryInfo, 1000);
  }

  startTimer(); // kick off
});
function moveSetOptionMainElement() {
  const mainElement = document.querySelector('#set_option_main');
  const targetElement = document.querySelector('#set_option');

  if (mainElement && targetElement) {
    targetElement.appendChild(mainElement); // Moves the whole element into #set_option
  } else {
    console.error('One or both elements not found.');
  }
}

moveSetOptionMainElement();


document.addEventListener('DOMContentLoaded', function () {
  const input = document.querySelector('#CartDrawer-Form #discountcodefieldcart');
  const button = document.querySelector('#CartDrawer-Form .news_letter_form button');

  if (input && button) {
    button.addEventListener('click', function () {
      const code = input.value.trim();

      if (code !== '') {
        const url = `/checkout?discount=${encodeURIComponent(code)}`;
        window.location.href = url;
      } else {
        alert('Voer een kortingscode in.'); // Optional: show message if empty
      }
    });
  }
});
